import {notify} from '@gemcook/notification';

import api from '@api';
import {Props} from './types';

export const deleteCard = async (
  props: Props,
  setIsDeleteModal: any,
  setDeleteLoading: any,
  setCardInfo: any
) => {
  try {
    setDeleteLoading(true);

    await api.payments.deleteCard(props.me.customerId);

    setCardInfo({last4: ''});
    setIsDeleteModal(false);

    notify('クレジットカードの削除に成功しました', 'success');
  } catch (error) {
    notify('クレジットカードの削除に失敗しました', 'error');
  } finally {
    setDeleteLoading(false);
  }
};
